import { render, staticRenderFns } from "./IntentionSwitch.vue?vue&type=template&id=51a67bc0&"
import script from "./IntentionSwitch.vue?vue&type=script&lang=js&"
export * from "./IntentionSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a67bc0')) {
      api.createRecord('51a67bc0', component.options)
    } else {
      api.reload('51a67bc0', component.options)
    }
    module.hot.accept("./IntentionSwitch.vue?vue&type=template&id=51a67bc0&", function () {
      api.rerender('51a67bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/IntentionSwitch.vue"
export default component.exports